export default __webpack_public_path__ + "static/media/token.9f89bdc0.png";